<template>
  <v-card
    v-if="properties != null"
    class="small-centered-card"
    flat
    height="100%"
  >
    <CImage
      v-if="properties.image != null"
      :url="properties.image"
      :alt="properties.title"
      :contain="image_contained"
      size="100px"
    ></CImage>
    <div class="card-content">
      <v-card-title
        v-if="properties.title != null"
        class="card-title small-centered-card-title dark_grey--text"
      >
        {{ properties.title }}
      </v-card-title>
      <v-card-subtitle v-if="properties.subtitle != null" class="card-subtitle">
        {{ properties.subtitle }}
      </v-card-subtitle>
      <v-card-text v-if="properties.paragraphe != null">
        <template v-for="(txt, id) in properties.paragraphe">
          <CText class="mt-3" :text="txt" :key="id" text_type="paragraphe" />
        </template>
      </v-card-text>
      <v-card-text v-if="properties.text != null">
        <template v-for="(elem, id) in properties.text">
          <CText
            class="mt-3"
            :text="elem"
            :key="id"
            :text_type="text_type"
            :color_text="text_color"
          />
        </template>
      </v-card-text>
      <div v-if="properties.list != null">
        <CList
          :list="properties.list"
          :color="this.$vuetify.theme.themes.light.blue_6"
        />
      </div>
    </div>
  </v-card>
</template>

<style scoped>
.small-centered-card {
  background-color: #fafefe;
  padding: 25px;
  border-radius: 14px;
}

.small-centered-card-title {
  justify-content: center;
}
</style>

<script>
import CImage from "../SubComponents/Image";
import CList from "../SubComponents/List";

export default {
  name: "SmallCenterCard",
  data: () => ({
    text_color: "medium_grey",
    text_type: "simple_text"
  }),
  components: {
    CImage,
    CList
  },
  props: {
    properties: {
      type: Object,
      default: null
    },
    image_contained: {
      type: Boolean,
      default: false
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style scoped>
.card-image {
  display: flex;
}
</style>
